import {
    fetchPendingOrders,
    fetchCompletedOrders,
    fetchTrades,
    fetchGTTOrders,
    fetchSIPOrders,
    placeSIPOrder,
    fetchAllOfs,
    pausePlaySIP,
    placeSIP,
    OfsOrdersByClient,
    fetchScripInfo,
    fetchHistoricalTradesList
  } from "../../services/backendAPI";
  import {
    getFormattedPendings,
    getFormattedCompleted,
    getFormattedTrades,
  } from "../../services/utilities/apiDataWithFrontendAddedKeys";
import { getOrderType } from "../../utils/utilfunction";
//   import alertify from "alertifyjs";
  
  export const fetchPendingOrdersAction = () => (dispatch) => {
    fetchPendingOrders()
      .then(({ data }) => {
        const pendingOrders = data.orders.map((order) =>
          getFormattedPendings(order)
        );
        dispatch({
          type: "SET_PENDING_ORDERS",
          payload: pendingOrders,
        });
      })
      .catch((err) =>
        dispatch({
          type: "SET_PENDING_ORDERS_ERROR_MESSAGE",
          payload: err,
        })
      );
  };
  
  export const fetchCompletedOrdersAction = () => (dispatch) => {
    fetchCompletedOrders()
      .then(({ data }) => {
        const completedOrders = data.orders.map((order) =>
          getFormattedCompleted(order)
        );
  
        dispatch({
          type: "SET_COMPLETED_ORDERS",
          payload: completedOrders,
        });
      })
  
      .catch((err) =>
        dispatch({
          type: "SET_COMPLETED_ORDERS_ERROR_MESSAGE",
          payload: err,
        })
      );
  };
  
  export const fetchTradesAction = () => (dispatch) => {
    fetchTrades()
      .then(({ data }) => {
        const tradeOrders = data.trades.map((order) => getFormattedTrades(order));
        dispatch({
          type: "SET_TRADES",
          payload: tradeOrders,
        });
      })
      .catch((err) =>
        dispatch({
          type: "SET_TRADES_ERROR_MESSAGE",
          payload: err,
        })
      );
  };
  
  export const setBasketOrder = (basketOrders) => (dispatch) => {
    dispatch({
      type: "SET_BASKET_ORDER",
      payload: basketOrders,
    });
  };
  
  export const fetchGTTOrdersAction = () => (dispatch) => {
    fetchGTTOrders()
      .then(({ data }) => {
        const formattedGTTOrders = data.map((item, idx) => {
          const newItem = {
            ...item.order,
            action_type: item.action_type,
            client_id: item.client_id,
            created_at: item.created_at,
            expiry_time: item.expiry_time,
            id: item.id,
            status: item.status,
            type: item.type,
            updated_at: item.updated_at,
          };
          return newItem;
        });
        dispatch({
          type: "SET_GTT_ORDERS",
          payload: formattedGTTOrders,
        });
      })
      .catch((err) => console.log(err));
  };
  
  export const placeSIPOrderAction = () => (dispatch) => {
    placeSIPOrder()
      .then(({ data }) => {
        dispatch({
          type: "PLACE_SIP_ORDER",
          payload: data,
        });
      })
      .catch((err) => console.log(err));
  };
  
  export const fetchSIPOrdersAction = () => (dispatch) => {
    fetchSIPOrders()
      .then(({ data }) => {
        dispatch({
          type: "SET_SIP_ORDERS",
          payload: data,
        });
      })
  
      .catch((err) => console.log(err));
  };
  
  export const fetchAllOfsAction = () => async (dispatch) => {
   
    fetchAllOfs()
      .then(({ data }) => {
        dispatch({
          type: "SET_ACTIVE_OFS",
          payload: data,
        });
      })
      .catch((err) => console.log(err));
  };
  
  export const fetchOfsOrdersByClient = (payload) => async (dispatch) => {
    OfsOrdersByClient(payload)
      .then(({ data }) => {
        dispatch({
          type: "FETCH_OFS_ORDERS",
          payload: data,
        });
      })
      .catch((err) => console.log(err));
  };
  
  
  export const pausePlaySIPAction = (id,payload,sipcontrol) => async(dispatch) => {
    try {
      const {data} = await pausePlaySIP(id,payload,sipcontrol);
      await dispatch(fetchSIPOrdersAction());
      return {status :"success",message: data.message};
    } catch (err) {
      return {status:"error",  message: err };
    }
  }
  
  export const sipordersWeekly = () => (dispatch) => {
    placeSIP()
    .then(({data}) => {
      dispatch({
        type:"SIP_ORDERS_WEEKLY",
        payload:data
      })
    })
    .catch((err) => console.log(err));
  }
  
  export const openOrderWindow = (instrumentData) => async (dispatch) => {
    
    // Preserve important original values, especially for modify orders
    const originalInstrumentName = instrumentData.instrument_name;
    
    try {
      const { result } = await fetchScripInfo(instrumentData.exchange, instrumentData.token);    
      // Ensure we have a payload that includes all necessary data
      const payload = {
        ...instrumentData,
        strike_price: result.strike,
        product: instrumentData.product,
        order_type: getOrderType(instrumentData.order_type),
        multiplier: result.multiplier,
        alernate_exchange: result.alternate_exchange,
        // Ensure instrument_name is always available
        instrument_name: result.instrument_name || originalInstrumentName || "",
        instrument_type: result.instrument_type,
        raw_board_lot_quantity: result.raw_board_lot_qty,
        have_futures: result.have_futures,
        have_options: result.have_options,
        tradable: result.tradable,
        series: result.series,
        isSquareOff: instrumentData.isSquareOff || false
      };
      
      const enrichedData = {
        open: true,
        type: instrumentData.type,
        trading_symbol: result.trading_symbol,
        display_name: result.display_name,
        ltp: instrumentData.ltp,
        alternate_exchange: result.alternate_exchange,
        exchange: instrumentData.exchange,
        token: instrumentData.token,
        strike_price: result.strike,
        multiplier: result.multiplier,
        lotsize: result.board_lot_quantity,
        tick_size: result.tick_size,
        execution: instrumentData.execution || 'REGULAR',
        bestBid: instrumentData.bestBidPrice,
        bestAsk: instrumentData.bestAskPrice,
        product: instrumentData.product,
        is_modify: instrumentData.is_modify,
        exchange_order_id: instrumentData.exchange_order_id,
        oms_order_id: instrumentData.oms_order_id,
        isSquareOff: instrumentData.isSquareOff || false,
        
        // For modify orders, ensure price and quantity are directly accessible
        price: instrumentData.is_modify ? instrumentData.price : undefined,
        quantity: instrumentData.is_modify ? instrumentData.quantity : undefined,
        
        // Add instrument_name to top level too
        instrument_name: result.instrument_name || originalInstrumentName || "",
        
        // Include the complete payload
        payload
      };

      dispatch({
        type: 'SET_ORDER_WINDOW',
        payload: enrichedData
      });
    } catch (err) {
      console.error('Error fetching scrip info:', err);
      
      // If we're modifying an order and scrip info fails, still proceed with what we have
      if (instrumentData.is_modify) {
        console.log("Falling back to original data for modify order");
        const fallbackData = {
          open: true,
          ...instrumentData,
          // Ensure we have an instrument_name
          instrument_name: originalInstrumentName || "UNKNOWN",
          payload: {
            ...instrumentData,
            instrument_name: originalInstrumentName || "UNKNOWN"
          }
        };
        
        dispatch({
          type: 'SET_ORDER_WINDOW',
          payload: fallbackData
        });
      }
    }
  };

  export const closeOrderWindow = () => ({
    type: 'CLOSE_ORDER_WINDOW'
  });

  export const updateOrderWindowType = (newType) => ({
    type: 'UPDATE_ORDER_WINDOW_TYPE',
    payload: newType
  });

  export const fetchTradeHistory = (params) => async (dispatch) => {
    try {
      const response = await fetchHistoricalTradesList(params);
      console.log("response", response);
      
      return response;
    } catch (error) {
      console.error("Error fetching trade history:", error);
      return {
        success: false,
        error: error.message || 'Error fetching trade history'
      };
    }
  };
  
  
  
  